query ActiveApprovalPhases {
  activeApprovalPhases(orderBy: ID_ASC) {
    nodes {
      id
      phaseName
      _activeCount
    }
  }
}